module.exports = __webpack_public_path__ + "static/media/confirmation-icon.8ac57c93.svg";